import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { OVERVIEW_HOLDING_DATA, } from "@frameworks/web/redux/interfaces/Reports/iAccountOverview";
import { EdelweissAssetClass } from "@domains/entities/interfaces/Reports/AccountOverview/IAccountOverView";
const initOverview = {
    accOverView: {
        holdingDetails: [],
        holdingSummary: {
            date: "",
            message: "",
            totalInvestment: "",
            currentValue: "",
            totalPnL: "",
            daysPnL: "",
            totalPnLChange: "",
            daysPnLChange: "",
        },
        assetClassWiseData: {
            [EdelweissAssetClass.EQUITY]: [],
            [EdelweissAssetClass.FI]: [],
            [EdelweissAssetClass.MP]: [],
            [EdelweissAssetClass.CO]: [],
            [EdelweissAssetClass.RE]: [],
        },
        assestClassDataFinal: [],
        managedPortfolioComposition: [],
        mutualFundComposition: [],
        fixedIncomeComposition: [],
    },
};
const OverviewHolidngDataReducer = (state = initOverview, action) => {
    switch (action.type) {
        case OVERVIEW_HOLDING_DATA:
            return Object.assign(Object.assign({}, state), { accOverView: action.payload.accOverView });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: OverviewHolidngDataReducer,
    commonData: commonOnePlatFormReducer,
});
